import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { PaymentDeclined } from './Banner/AccountIssue/PaymentDeclined';
import UnverifiedAlert from './Banner/UnverifiedAlert';
import { DISABLED_UNVERIFIED_BANNER_PATHS } from '../../constants';

// BannerNotifications component for page banner
// to support showing a single BannerNotification at a time
const BannerNotifications = ({ user }) => {
  const { email, verified } = user;
  // self serve payment processing failed
  if (user.last_payment_failed && !user.hasTestObjectPlan() && user.canSelfServe()) {
    return (
      <PaymentDeclined
        isOrganizationAdmin={user.isOrgAdmin()}
        isTeamAdmin={user.isTeamAdmin()}
      />
    );
  }

  const { pathname } = window.location;
  const shouldDisableUnverifiedAlert = DISABLED_UNVERIFIED_BANNER_PATHS.some(
    (disabledPath) => pathname.startsWith(disabledPath),
  );

  if (!verified && email && !shouldDisableUnverifiedAlert) {
    return (
      <UnverifiedAlert
        data-qa="unverified-alert"
        email={email}
      />
    );
  }

  return null;
};

BannerNotifications.propTypes = {
  user: ImmutablePropTypes.record.isRequired,
};

export default BannerNotifications;
